import { render, staticRenderFns } from "./BankingInformation.vue?vue&type=template&id=328b18ea&scoped=true"
import script from "./BankingInformation.vue?vue&type=script&lang=js"
export * from "./BankingInformation.vue?vue&type=script&lang=js"
import style0 from "./BankingInformation.vue?vue&type=style&index=0&id=328b18ea&prod&lang=css"
import style1 from "./BankingInformation.vue?vue&type=style&index=1&id=328b18ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b18ea",
  null
  
)

export default component.exports